// Removed locales import - landing pages don't need i18next
// import './locales';

import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';

import Layout from '@/components/layouts';
import Theme from '@/components/template/Theme';
import appConfig from '@/configs/app.config';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
// Removed devtools from production - saves bundle size
// import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

// mockServer removed - miragejs was bundled (~50KB) even when enableMock: false
// If mock needed in development, use dynamic import:
// if (appConfig.enableMock) { import('./mock').then(m => m.default({ environment: process.env.NODE_ENV })); }
import store, { persistor } from './store';

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {},
	},
});

function App() {
	return (
		<Provider store={store}>
			<QueryClientProvider client={queryClient}>
				<PersistGate loading={null} persistor={persistor}>
					<BrowserRouter>
						<Theme>
							<Layout />
						</Theme>
					</BrowserRouter>
				</PersistGate>
				{/* Removed ReactQueryDevtools for production performance */}
			</QueryClientProvider>
		</Provider>
	);
}

export default App;
